"use client";

import { c as _c } from "react/compiler-runtime";
import DropPfp from "@/components/drops/create/utils/DropPfp";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
import { useIdentity } from "@/hooks/useIdentity";
import { useIdentityBalance } from "@/hooks/useIdentityBalance";
import UserFollowBtn, { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import UserCICTypeIcon from "../user-cic-type/UserCICTypeIcon";
import UserLevel from "../level/UserLevel";
import { CLASSIFICATIONS, CicStatement } from "@/entities/IProfile";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
export default function UserProfileTooltip(t0) {
  const $ = _c(96);
  const {
    user
  } = t0;
  let t1;
  if ($[0] !== user) {
    t1 = {
      handleOrWallet: user,
      initialProfile: null
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  const t2 = profile?.consolidation_key ?? null;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      consolidationKey: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: balance
  } = useIdentityBalance(t3);
  let t4;
  if ($[4] !== user) {
    t4 = user.toLowerCase();
    $[4] = user;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = [QueryKey.PROFILE_CIC_STATEMENTS, t4];
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== user) {
    t6 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/cic/statements`
    });
    $[8] = user;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !!user && !!profile?.handle;
  let t8;
  if ($[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = {
      queryKey: t5,
      queryFn: t6,
      enabled: t7
    };
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const {
    data: statements
  } = useQuery(t8);
  const [aboutStatement, setAboutStatement] = useState(null);
  let t10;
  let t9;
  if ($[14] !== statements) {
    t9 = () => {
      const about = statements?.find(_temp);
      setAboutStatement(about ?? null);
    };
    t10 = [statements];
    $[14] = statements;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  const description = profile?.classification ? CLASSIFICATIONS[profile.classification]?.title : null;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const profileHandle = profile?.handle ?? null;
  let t11;
  if ($[17] !== profileHandle) {
    t11 = profileHandle?.toLowerCase() ?? null;
    $[17] = profileHandle;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const normalizedProfileHandle = t11;
  let t12;
  if ($[19] !== connectedProfile?.handle) {
    t12 = () => connectedProfile?.handle?.toLowerCase() ?? null;
    $[19] = connectedProfile?.handle;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  connectedProfile?.handle;
  let t13;
  if ($[21] !== t12) {
    t13 = t12();
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const normalizedConnectedHandle = t13;
  const showFollowButton = Boolean(normalizedProfileHandle && normalizedProfileHandle !== normalizedConnectedHandle);
  const t14 = profile?.pfp;
  let t15;
  if ($[23] !== t14) {
    t15 = <div className="tw-flex-shrink-0"><DropPfp pfpUrl={t14} /></div>;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = profile?.handle ?? profile?.display;
  let t17;
  if ($[25] !== t16) {
    t17 = <span className="tw-text-base tw-font-bold tw-text-iron-50 tw-truncate tw-max-w-[180px]">{t16}</span>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== profile) {
    t18 = profile && <div className="tw-h-5 tw-w-5"><UserCICTypeIcon cic={profile.cic} /></div>;
    $[27] = profile;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t17 || $[30] !== t18) {
    t19 = <div className="tw-flex tw-items-center tw-gap-x-2">{t17}{t18}</div>;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== description) {
    t20 = description && <p className="tw-text-xs tw-text-iron-400 tw-mb-0">{description}</p>;
    $[32] = description;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== profile) {
    t21 = profile && <div className="tw-mt-1.5"><UserLevel level={profile.level} size="xs" /></div>;
    $[34] = profile;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t19 || $[37] !== t20 || $[38] !== t21) {
    t22 = <div className="tw-flex tw-flex-col tw-min-w-0">{t19}{t20}{t21}</div>;
    $[36] = t19;
    $[37] = t20;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t15 || $[41] !== t22) {
    t23 = <div className="tw-flex tw-gap-x-3 tw-flex-1 tw-min-w-0">{t15}{t22}</div>;
    $[40] = t15;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== profileHandle || $[44] !== showFollowButton) {
    t24 = showFollowButton && profileHandle && <div className="tw-flex-shrink-0"><UserFollowBtn handle={profileHandle} size={UserFollowBtnSize.SMALL} /></div>;
    $[43] = profileHandle;
    $[44] = showFollowButton;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t23 || $[47] !== t24) {
    t25 = <div className="tw-flex tw-flex-col tw-gap-y-2"><div className="tw-flex tw-items-start tw-justify-between tw-gap-x-4">{t23}{t24}</div></div>;
    $[46] = t23;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== aboutStatement) {
    t26 = aboutStatement && <p className="tw-text-sm tw-text-iron-200 tw-line-clamp-6 tw-mb-0 tw-mt-4">{aboutStatement.statement_value}</p>;
    $[49] = aboutStatement;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  const t27 = profile?.tdh ?? 0;
  let t28;
  if ($[51] !== t27) {
    t28 = formatNumberWithCommasOrDash(t27);
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t28) {
    t29 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t28}</span>;
    $[53] = t28;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span className="tw-text-sm tw-text-iron-400">TDH</span>;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t29) {
    t31 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t29}{t30}</div>;
    $[56] = t29;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  const t32 = profile?.tdh_rate ?? 0;
  let t33;
  if ($[58] !== t32) {
    t33 = formatNumberWithCommasOrDash(t32);
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t33) {
    t34 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t33}</span>;
    $[60] = t33;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <span className="tw-text-sm tw-text-iron-400">TDH Rate</span>;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  if ($[63] !== t34) {
    t36 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t34}{t35}</div>;
    $[63] = t34;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  const t37 = profile?.rep ?? 0;
  let t38;
  if ($[65] !== t37) {
    t38 = formatNumberWithCommasOrDash(t37);
    $[65] = t37;
    $[66] = t38;
  } else {
    t38 = $[66];
  }
  let t39;
  if ($[67] !== t38) {
    t39 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t38}</span>;
    $[67] = t38;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  let t40;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <span className="tw-text-sm tw-text-iron-400">REP</span>;
    $[69] = t40;
  } else {
    t40 = $[69];
  }
  let t41;
  if ($[70] !== t39) {
    t41 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t39}{t40}</div>;
    $[70] = t39;
    $[71] = t41;
  } else {
    t41 = $[71];
  }
  const t42 = profile?.cic ?? 0;
  let t43;
  if ($[72] !== t42) {
    t43 = formatNumberWithCommasOrDash(t42);
    $[72] = t42;
    $[73] = t43;
  } else {
    t43 = $[73];
  }
  let t44;
  if ($[74] !== t43) {
    t44 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t43}</span>;
    $[74] = t43;
    $[75] = t44;
  } else {
    t44 = $[75];
  }
  let t45;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <span className="tw-text-sm tw-text-iron-400">NIC</span>;
    $[76] = t45;
  } else {
    t45 = $[76];
  }
  let t46;
  if ($[77] !== t44) {
    t46 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t44}{t45}</div>;
    $[77] = t44;
    $[78] = t46;
  } else {
    t46 = $[78];
  }
  const t47 = balance?.total_balance ?? 0;
  let t48;
  if ($[79] !== t47) {
    t48 = formatNumberWithCommasOrDash(t47);
    $[79] = t47;
    $[80] = t48;
  } else {
    t48 = $[80];
  }
  let t49;
  if ($[81] !== t48) {
    t49 = <span className="tw-text-sm tw-font-semibold tw-text-iron-50">{t48}</span>;
    $[81] = t48;
    $[82] = t49;
  } else {
    t49 = $[82];
  }
  let t50;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <span className="tw-text-sm tw-text-iron-400">Balance</span>;
    $[83] = t50;
  } else {
    t50 = $[83];
  }
  let t51;
  if ($[84] !== t49) {
    t51 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t49}{t50}</div>;
    $[84] = t49;
    $[85] = t51;
  } else {
    t51 = $[85];
  }
  let t52;
  if ($[86] !== t31 || $[87] !== t36 || $[88] !== t41 || $[89] !== t46 || $[90] !== t51) {
    t52 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1.5 tw-mt-4">{t31}{t36}{t41}{t46}{t51}</div>;
    $[86] = t31;
    $[87] = t36;
    $[88] = t41;
    $[89] = t46;
    $[90] = t51;
    $[91] = t52;
  } else {
    t52 = $[91];
  }
  let t53;
  if ($[92] !== t25 || $[93] !== t26 || $[94] !== t52) {
    t53 = <div className="tailwind-scope tw-bg-iron-950 tw-min-w-[280px] tw-max-w-[320px]">{t25}{t26}{t52}</div>;
    $[92] = t25;
    $[93] = t26;
    $[94] = t52;
    $[95] = t53;
  } else {
    t53 = $[95];
  }
  return t53;
}
function _temp(statement) {
  return statement.statement_type === STATEMENT_TYPE.BIO && statement.statement_group === STATEMENT_GROUP.GENERAL;
}